import { useState, useCallback, useEffect } from 'react';
import recipeService from '../services/recipeService';
import { RecipeData } from '../types';
import { filter } from 'lodash';

interface UseRecipeHistoryReturn {
  recipes: RecipeData[];
  loading: boolean;
  error: string | null;
  refreshHistory: () => Promise<void>;
  deleteRecipe: (recipeId: string) => Promise<void>;
}

export const useRecipeHistory = (refreshRecipeTrigger: any): UseRecipeHistoryReturn => {
  const [recipes, setRecipes] = useState<RecipeData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const refreshHistory = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const list = await recipeService.getRecipeHistory();
      const chatList = await recipeService.getRecipeChatHistory();
      // console.log("获取到的配方列表:", list);
      // console.log("获取到的对话列表:", chatList);
      
      // 在chatList中找到对应list中的配方id的对话，赋值给chatHistory属性
      const history = list.map(recipe => {
        const chatRecipe = chatList.filter(chat => chat.tableId === recipe.id);
        //chatRecipe按timestamp排序
        chatRecipe.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
        return {
          ...recipe,
          chatHistory: chatRecipe,
        };
      });
      // console.log("获取历史记录成功:", history);
      setRecipes(history);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : '获取历史记录失败';
      setError(errorMessage);
      console.error('刷新配方历史失败:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteRecipe = useCallback(async (recipeId: string) => {
    try {
      await recipeService.deleteRecipe(recipeId);
      setRecipes(prev => prev.filter(recipe => recipe.id !== recipeId));
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : '删除配方失败';
      setError(errorMessage);
      console.error('删除配方失败:', err);
      throw err;
    }
  }, []);

  // 组件挂载时自动加载历史记录
  useEffect(() => {
    refreshHistory();
  }, [refreshHistory, refreshRecipeTrigger]);

  return {
    recipes,
    loading,
    error,
    refreshHistory,
    deleteRecipe,
  };
};